import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import PromotionBanner from "elements/PromotionBanner";
import Flickity from "react-flickity-component";
import DOMPurify from "dompurify";
import api from "services/api";
import { __ } from "services/Translator";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import Slider from "react-slick";
import FeturedItem from "elements/FeturedItem";
import WelcomePromotions from "elements/WelcomePromotions";
// components
import Faqs from "../elements/Faqs";
import BottomBanner from "../elements/BottomBanner";
// import Banner from "../elements/Banner";

export default function Promotions(props) {
  // const __ = (text) => text;

  // BONUS
  const prevBonus = () => {
    bonusRef.current.slickPrev();
  };
  const nextBonus = () => {
    bonusRef.current.slickNext();
  };

  const bonusSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: false,
    customPaging: function (i) {
      return (
        <a className={props.landingType}>
          <div className="round">
            <i class="fas fa-circle"></i>
          </div>
          <div className="line"></div>
        </a>
      );
    },
    dotsClass: "slick-dots deposit_slider_dots",
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const bonusRef = useRef();

  //

  const flkty = useRef(null);

  const nextLoad = () => {
    flkty.current.next();
  };

  const prevLoad = () => {
    flkty.current.previous();
  };

  const isAuthenticated = props.isAuthenticated;
  const [pageContent, setPageContent] = useState({});
  const [promotionsData, setPromotionsData] = useState([]);

  const getResults = async () => {
    var response = await api.get("/promotions");

    if (response.status === 200) {
      setPageContent(response.data.content_data);
      setPromotionsData(response.data.promotions);
    } else {
      props.showAlert(null, response.data.message, true);
    }
  };

  const toggleExpanded = (index) => {
    var promotionsClone = JSON.parse(JSON.stringify(promotionsData));
    promotionsClone[index].expanded = !promotionsClone[index].expanded;
    setPromotionsData(promotionsClone);
  };

  const pageName = props.pageName;

  useEffect(() => {
    // getResults();
  }, []);

  //Get Promotion functionality
  const [mobilePromotions, setMobilePromotions] = useState([]);
  const [promotionGroup, setpromotionGroup] = useState([]);
  const getPromotions = async (page) => {
    props.setSpinner(true);
    var response = await api.get("/promotions", {
      promotion_type: "Deposit",
    });
    props.setSpinner(false);
    if (response.status === 200) {
      // console.log("response.data.promotions", response.data.promotions);
      setPromotionsData(response.data);
      setMobilePromotions(response.data.promotions);
      const promo = response.data.promotions;
      // response.data.promotions.forEach((item, index) => {
      //   console.log("itemitemitem", item);
      // });
      const chunks = [];
      const chunkSize = 3;
      for (let i = 0; i < promo.length; i += chunkSize) {
        chunks.push(promo.slice(i, i + chunkSize));
      }
      setPromotionsData(chunks);
    }
  };

  useEffect(() => {
    getPromotions();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {__(
            "Joker Casino | Get Bonuses on your first 2 Deposits, see what else is available here!"
          )}
        </title>
        <meta
          name="description"
          content={__(
            "Joker Casino! See all the latest fun Promotions we run which give you extra play for your buck - Check back regularly for all the latest news!"
          )}
        />
      </Helmet>

      <div className="promotions_page">
        <section className="games_banner">
          <div className="slick_item">
            <div className="container-xxl">
              <div className="promotions_nav">
                <Link to="/welcome-promotions" className="item">
                  <span
                    className={
                      (pageName === "welcome-promotions"
                        ? "active show "
                        : "active ") + props.landingType
                    }
                  ></span>
                  {__("Welcome Promotions")}
                </Link>
                <Link to="/slots-promotions" className="item">
                  <span
                    className={
                      (pageName === "slots-promotions"
                        ? "active show "
                        : "active ") + props.landingType
                    }
                  ></span>
                  {__("Slots Promotions")}
                </Link>
                <Link to="/sportsbook-promorions" className="item">
                  <span
                    className={
                      (pageName === "sportsbook-promorions"
                        ? "active show "
                        : "active ") + props.landingType
                    }
                  ></span>
                  {__("Sportsbook Promotions")}
                </Link>
                <Link to="/poker-promotions" className="item">
                  <span
                    className={
                      (pageName === "poker-promotions"
                        ? "active show "
                        : "active ") + props.landingType
                    }
                  ></span>
                  {__("Poker Promotions")}
                </Link>
              </div>

              {/*  align-self-center */}
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="banner_heading padding_top_15">
                    {__("20 Free Spins")}
                  </div>
                  <div className="banner_heading">{__("No Deposit.")}</div>
                  <div className={"banner_title_italic " + props.landingType}>
                    {__("ON ANY SLOT GAME.")}
                  </div>

                  <div className="paragraph margin_top_30">
                    {__(
                      "Register and start playing right away with 20 Free Spins on a selection"
                    )}
                  </div>
                  <div className="paragraph">
                    {__(
                      "of awesome, thrilling games. You decide which game you want to play the free spins on."
                    )}
                  </div>

                  <div className="banner_count white_border margin_top_30">
                    {props.totals && (
                      <>
                        <div className="count_area">
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalPlayers}+
                            </div>
                            <div className="paragraph">
                              {__("Players Online")}
                            </div>
                          </div>
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalGames}+
                            </div>
                            <div className="paragraph">{__("Games")}</div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="custom_btn">
                      {props.isAuthenticated ? (
                        <Link
                          to="/games/slots"
                          className={"angle_btn " + props.landingType}
                        >
                          {__("Play Now")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="red"
                            class="bi bi-arrow-right"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                            />
                          </svg>
                        </Link>
                      ) : (
                        <Link
                          onClick={() => {
                            props.setModalSignUpPropsData(true);
                          }}
                          className={"angle_btn " + props.landingType}
                        >
                          {__("Sign Up Now")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="red"
                            class="bi bi-arrow-right"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                            />
                          </svg>
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="banner_img">
                    {props.isMobileDevice ? (
                      <img
                        alt="game image"
                        src={
                          require("assets/images/banners/roulette-ii-mobile.png")
                            .default
                        }
                      />
                    ) : (
                      <img
                        alt="game image"
                        src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <br />

        <section className="game_section">
          <div className="container">
            {/* <div className="section_title margin_top_15">
              {__("Our Selection")}
            </div>
            <div className="paragraph text-center">
              {__(
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod"
              )}
            </div>
            <div className="paragraph text-center margin_bottom_15">
              {__("tempor, Lorem ipsum dolor .")}
            </div>

            <div className="section_headline margin_top_15 margin_bottom_30">
              <div className="headline_text">
                {__("Promotions of the Week")}
              </div>
            </div> */}

            {promotionsData.length > 0 && (
              <div className="promotions_slider">
                <Slider ref={bonusRef} {...bonusSettings}>
                  {promotionsData.map((item, index) => (
                    <div className="slick_item ">
                      <div className="row">
                        <div className="col-12 col-md-12 col-lg-7 col-xl-8">
                          <div className="promotion_single_slider">
                            <div className="promotion_img">
                              <img
                                className="big"
                                alt="game image"
                                src={item[0]?.image}
                              />
                            </div>
                            <div className="promotion_text big">
                              <div className="badge">{__("Popular")}</div>

                              <div className="title italic big margin_top_15">
                                {__("GET YOUR WELCOME PACKAGE")}
                              </div>
                              <div className="title headline padding_bottom_0 big">
                                {item[0].title}
                              </div>

                              <Link
                                onClick={() => {
                                  props.setModalSignUpPropsData(true);
                                }}
                                className={
                                  "angle_btn margin_top_15  border_white " +
                                  props.landingType
                                }
                              >
                                {__("Sign Up Now")}

                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="25"
                                  height="25"
                                  fill="red"
                                  class="bi bi-arrow-right"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                  />
                                </svg>
                              </Link>

                              <div className="date margin_top_15 d-none">
                                <span className="indicate"></span>August 27th,
                                2028
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-12 col-lg-5 col-xl-4">
                          <div className="promotion_single_slider margin_top_mobile">
                            <div className="promotion_img">
                              <img alt="game image" src={item[1]?.image} />
                            </div>
                            <div className="promotion_text">
                              <div className="badge">{__("Popular")}</div>

                              <div className="title italic margin_top_15">
                                {__("GET YOUR WELCOME PACKAGE")}
                              </div>
                              <div className="title headline padding_bottom_0">
                                {item[0].title}
                              </div>

                              <div className="date d-none">
                                <span className="indicate"></span>August 27th,
                                2028
                              </div>
                            </div>
                          </div>

                          <div className="promotion_single_slider margin_top_15">
                            <div className="promotion_img">
                              <img alt="game image" src={item[2]?.image} />
                            </div>
                            <div className="promotion_text">
                              <div className="badge">{__("Popular")}</div>

                              <div className="title italic margin_top_15">
                                {__("GET YOUR WELCOME PACKAGE")}
                              </div>
                              <div className="title headline padding_bottom_0">
                                {item[1].title}
                              </div>

                              <div className="date d-none">
                                <span className="indicate"></span>August 27th,
                                2028
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            )}

            {/* Promotion Slider */}
            <div className="promotions_slider d-none">
              <Slider ref={bonusRef} {...bonusSettings}>
                <div className="slick_item">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-7 col-xl-8">
                      <div className="promotion_single_slider">
                        <div className="promotion_img">
                          <img
                            className="big"
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=856&h=464&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text big">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic big margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0 big">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline big padding_top_0">
                            {__("of your Deposit")}
                          </div>

                          <Link
                            onClick={() => {
                              props.setModalSignUpPropsData(true);
                            }}
                            className={
                              "angle_btn margin_top_15  border_white " +
                              props.landingType
                            }
                          >
                            {__("Sign Up Now")}

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="red"
                              class="bi bi-arrow-right"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              />
                            </svg>
                          </Link>

                          <div className="date margin_top_15">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-5 col-xl-4">
                      <div className="promotion_single_slider margin_top_mobile">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>

                      <div className="promotion_single_slider margin_top_15">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slick_item">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-7 col-xl-8">
                      <div className="promotion_single_slider">
                        <div className="promotion_img">
                          <img
                            className="big"
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=856&h=464&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text big">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic big margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0 big">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline big padding_top_0">
                            {__("of your Deposit")}
                          </div>

                          <Link
                            onClick={() => {
                              props.setModalSignUpPropsData(true);
                            }}
                            className={
                              "angle_btn margin_top_15  border_white " +
                              props.landingType
                            }
                          >
                            {__("Sign Up Now")}

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="red"
                              class="bi bi-arrow-right"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              />
                            </svg>
                          </Link>

                          <div className="date margin_top_15">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-5 col-xl-4">
                      <div className="promotion_single_slider margin_top_mobile">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>

                      <div className="promotion_single_slider margin_top_15">
                        <div className="promotion_img">
                          <img
                            alt="game image"
                            src="https://chimpbytes.imgix.net/promotion-slide-1.png?&dpr=1&format=auto&auto=format&w=416&h=220&max-age=2629056"
                          />
                        </div>
                        <div className="promotion_text">
                          <div className="badge">{__("Popular")}</div>

                          <div className="title italic margin_top_15">
                            {__("GET YOUR WELCOME PACKAGE")}
                          </div>
                          <div className="title headline padding_bottom_0">
                            {__("100% Monthly Bonus")}
                          </div>
                          <div className="title headline padding_top_0">
                            {__(" of your Deposit")}
                          </div>

                          <div className="date">
                            <span className="indicate"></span>August 27th, 2028
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>

            <div className="slider_prev_next ">
              <button onClick={prevBonus} className="action_btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="20"
                  fill="white"
                >
                  <path
                    fill-rule="evenodd"
                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                  />
                </svg>
                {__("Prev")}
              </button>
              <button onClick={nextBonus} className="action_btn">
                {__("Next")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="20"
                  fill="white"
                  class="bi bi-arrow-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </section>
        {/* <FeturedItem {...props} /> */}
        {!props.isMobileDevice && <WelcomePromotions {...props} />}
        <BottomBanner {...props} />
        <Faqs {...props} />
      </div>

      {/* <PromotionBanner pageName="promotion" {...props} /> */}
    </>
  );
}
